import React from 'react';

interface Partner {
  name: string;
  logo: string;
  url?: string;
  invertLogo?: boolean;
}

const PartnerSection = () => {
  const partners: Partner[] = [
    {
      name: 'Flare',
      logo: '/images/partners/flare_logo.svg',
      url: 'https://flare.network',
    },
    {
      name: 'Hedera',
      logo: '/images/partners/hedera_logo.svg',
      url: 'https://hedera.com',
    },
    {
      name: 'CMIT',
      logo: '/images/partners/CMIT_Logo_white.png',
      url: 'https://cmit.org',
      invertLogo: true,
    },
    {
      name: 'OCI',
      logo: '/images/partners/logo-oci-color-en.svg',
      url: 'https://www.oracle.com/cloud',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Partners
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by leading organizations in blockchain and enterprise solutions
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 items-center justify-center">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center group"
              aria-label={`Visit ${partner.name}`}
            >
              <div className="w-full h-28 md:h-32 flex items-center justify-center p-3 rounded-lg shadow-sm group-hover:shadow-md transition-shadow duration-300 border bg-white border-gray-200">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className={`w-32 md:w-36 h-24 md:h-28 object-contain grayscale group-hover:grayscale-0 transition-all duration-300 ${
                    partner.invertLogo ? 'invert' : ''
                  }`}
                  loading="lazy"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerSection;
